import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateRegistrationRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-registration",
            component: () => loadView(import("./AssociateRegistrationTable.vue")),
        },
        build(filter?: { status?: Enums.AssociateRegistrationStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/associate-registration?&filter=${encoded}`;
            }

            return "/associate-registration";
        },
    },
    update: {
        route: {
            path: "/associate-registration/:id",
            component: () => loadView(import("./AssociateRegistrationUpdate.vue")),
        },
        build(id: string) {
            return `/associate-registration/${id}`;
        },
    },
});
